import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'kmb' })
export class KmbPipe implements PipeTransform {
  transform(value: number): string {
    if (value >= 1e9) {
      return (value / 1e9).toFixed(0) + 'B';
    } else if (value >= 1e6) {
      return (value / 1e6).toFixed(0) + 'M';
    } else if (value >= 1e3) {
      return (value / 1e3).toFixed(0) + 'K';
    }
    return value.toString();
  }
}
